import { Box, Typography } from "@mui/material";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./customHooks/useAuth";
import Menu from "./layout/Menu";

/**
 * App
 * ----
 * Layout principale dell'applicazione e "protected route".
 *
 * Responsabilità:
 * - Verificare lo stato di autenticazione
 * - Bloccare l’accesso alle rotte protette se l’utente non è loggato
 * - Renderizzare il layout comune (menu, footer)
 * - Ospitare le route figlie tramite <Outlet />
 */
function App() {
  const auth = useAuth();
  const location = useLocation();

  /**
   * Guard di autenticazione.
   *
   * Se l’utente NON è autenticato:
   * - viene reindirizzato alla pagina di login
   * - nello state viene salvata la rotta richiesta (location.pathname)
   *   per poterci tornare dopo il login
   * - replace evita di sporcare l’history (niente “back” verso la pagina protetta)
   */
  if (!auth.isLogged) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  /**
   * Layout principale dell'app.
   *
   * Viene renderizzato solo se l’utente è autenticato.
   * Contiene:
   * - Header con menu di navigazione
   * - Area centrale per le route figlie (<Outlet />)
   * - Footer informativo
   */
  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      overflow="hidden"
    >
      {/* Header */}
      <Box py={1} px={2} boxShadow={3}>
        <Menu />
      </Box>

      {/* Contenuto dinamico delle route figlie */}
      <Box
        position="relative"
        display="flex"
        height="100%"
        overflow="hidden"
        minHeight={0}
      >
        <Outlet />
      </Box>

      {/* Footer */}
      <Box display="flex" justifyContent="center" alignItems="center">
        <Typography fontSize="0.8rem">
          &#169; Trendrating - CRM {new Date().getFullYear()}{" "}
          {`v ${process.env.REACT_APP_VERSION}`}
        </Typography>
      </Box>
    </Box>
  );
}

export default App;
